import axios from "axios"



export const getProductsApi = (payload) => {
	 
	const prodUrl = process.env.REACT_APP_BASE_URL_TWO
    
	return (
		axios
			.get(prodUrl+`inventory/api/v1/product/?page=${payload}`)
			 
			.then(function (response) {
				// console.log(response);
				return response
			})
			.catch((error) => {
			 
				return error
			})
	)
}
